import SectionHeader from "../components/SectionHeader";
import SectionLayout from "../components/SectionLayout";
import { AnimationOnScroll } from "react-animation-on-scroll";

export default function Hero() {
  return (
    <SectionLayout id="about" index={1}>
      <SectionHeader>About</SectionHeader>
      <AnimationOnScroll animateIn="animate__fadeIn">
        <div className="flex flex-col lg:flex-row w-full">
          <div className=" p-16 sm:p-24 flex justify-center items-center about-section-left-back bg-center bg-contain bg-no-repeat">
            <img
              className=" sm:max-w-xs rotate-6"
              alt="ahmed azad profile"
              src={require("../assets/avatar.jpg")}
            />
          </div>
          <div className=" w-full flex-shrink flex items-center sm:text-2xl p-6 sm:p-8 about-section-right-back bg-center bg-cover lg:bg-contain bg-no-repeat">
            Ahmed Azad, Diploma in Information Technology, currently studying
            Information System Engineering, and I have participated in several
            courses and bootcamps related to coding and other fields such as
            Photography and Grahics Design. I love Tech and Computer
            Programming. At present, I mostly work in Front-End development with
            React js. My motive is my curiosity to understand how modern
            technology has come this far and how it works under the hood.
          </div>
        </div>
      </AnimationOnScroll>
    </SectionLayout>
  );
}
